<mat-form-field appearance="outline" color="accent">
  <input
    [value]="defaultAddress"
    matInput
    #addresstext
    placeholder="{{ inputText | translate }}"
    (keydown)="onInputKeydown($event)"
  />
</mat-form-field>
